import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../../styles/styles-css-variables";
import React from "react";

export const PCPHr = (
  <hr
    css={css`
      margin: 16px 0;
      width: 100%;

      height: 1px;

      border: none;
      background-color: ${CSS_COLORS.Grey2};
    `}
  />
);
